<template>
  <div id="home">
    <div style="width: 90%">
      <patternlib-headline
        separator="none"
        :headline="$t('welcome.headline', { name: name })"
        heading-tag="h1"
      ></patternlib-headline>
      <p style="margin-top: 20px">{{ $t('welcome.text') }}</p>
    </div>
    <div id="content" style="width: 90%">
      <router-link
        to="/myAppliances"
        v-if="global.registeredApplianceAvailable"
        :aria-label="$t('myRegisteredAppliances')"
      >
        <div style="width: 100%; margin-top: 20px" aria-hidden="true">
          <img
            :alt="$t('myRegisteredAppliances')"
            src="@/assets/img/myAppliances.png"
            style="max-height: 384px; width: 100%; object-fit: cover"
            class="menuImage"
          />
          <patternlib-link
            :label="$t('myRegisteredAppliances')"
            uppercase="false"
            icon-position="right"
            style="margin-top: 10px"
            variant="context"
          >
          </patternlib-link>
        </div>
      </router-link>
      <registerApplianceBanner v-if="!global.registeredApplianceAvailable" />
      <div id="subcontent">
        <router-link
          to="/myOrders"
          v-if="global.showOrders"
          style="width: 100%"
          :aria-label="$t('myOrders.headline')"
        >
          <div aria-hidden="true">
            <img
              :alt="$t('myOrders.headline')"
              src="@/assets/img/myOrders.png"
              style="max-height: 384px; width: 100%; object-fit: cover"
              class="menuImage"
            />
            <patternlib-link
              :label="$t('myOrders.headline')"
              uppercase="false"
              icon-position="right"
              style="margin-top: 10px"
              variant="context"
            >
            </patternlib-link>
          </div>
        </router-link>
        <router-link to="/myAccount" style="width: 100%" :aria-label="$t('myData')">
          <div aria-hidden="true">
            <img
              :alt="$t('myData')"
              src="@/assets/img/myAccount.png"
              style="max-height: 384px; width: 100%; object-fit: cover"
              class="menuImage"
            />
            <patternlib-link
              :label="$t('myData')"
              uppercase="false"
              icon-position="right"
              style="margin-top: 10px"
              variant="context"
            >
            </patternlib-link>
          </div>
        </router-link>
      </div>
    </div>

    <ShopBanner style="margin-top: 96px" v-if="global.showOrders"></ShopBanner>
  </div>
</template>

<script>
  import registerApplianceBanner from '../components/registerApplianceBanner.vue';
  import ShopBanner from '../components/shopBanner.vue';
  import { useAuth } from '../stores/authStore';
  import { useGlobal } from '../stores/globalStore';

  export default {
    data: () => ({
      name: '',
      noRegisteredAppliances: false
    }),

    components: {
      ShopBanner,
      registerApplianceBanner
    },

    computed: {
      global: () => useGlobal()
    },

    methods: {},

    mounted() {
      // const services = useServices();
      // const globalStore = useGlobal();
      // services.$api.getDwlConfigurationPage((res) => {
      //     globalStore.accessoryShopUrl = res;
      // }, globalStore.language, globalStore.country, "Accessory", window.location.origin);
    },

    created() {
      const authStore = useAuth();
      this.name = authStore.name;
    }
  };
</script>

<style lang="scss" scoped>
  #home {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #subcontent {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    margin-top: 20px;
  }

  @media only screen and (max-width: 770px) {
    .menuImage {
      height: 160px;
    }
  }
</style>
